import { useState } from 'react'
import Button from '../../../components/Button'
import Card from '../../../components/Card'
import { ReactComponent as Illustration } from './illustration.svg'
import classNames from 'classnames'


export default function EdgeStep({ onSubmit }) {
  let [isLoading, setIsLoading] = useState(false)
  return (
    <div className='flex flex-col w-full h-full items-center justify-center'>
      {isLoading &&
        <div className="spinner spinner-relative">
          <i className="animate-spin bx bx-loader-alt text-4xl text-primary"></i>
        </div>
      }
      <Card withGradient>

        <div className='px-24 py-12 flex text-white gap-12 items-center'>
          <div className='flex flex-col gap-4 w-72 items-start'>
            <div className='text-2xl font-bold'>
              Das kannst du mit Edge erreichen!
            </div>
            <div className='text-neutral-500 text-lg'>
              Andere haben es auch geschafft. Genau deshalb kannst du das auch, tauche in die Welt unserer Kundenerfolge ein und werde der nächste Top Seller auf Amazon.
            </div>
            <Button 
              variant='secondary' 
              onClick={async () => {
                setIsLoading(true)
                try {
                  await onSubmit()
                } catch (e) {
                  setIsLoading(false)
                }
              }}
              disabled={isLoading}
            >
              <strong className={classNames('font-bold px-12', { 'text-primary': !isLoading })}>Weiter</strong>
            </Button>
          </div>

          <div className='flex flex-col gap-6'>
            <Illustration className='w-96 h-auto' />
          </div>
        </div>
      </Card>
    </div>
  )
}
